<template>
    <div class="container">
        <div class="row h-100 register">
            <div class="col-12 col-lg-10 mx-auto  pb-4 bg-white shadow-sm">
                <div class="row" v-if="savings">
                    <div class="col-12 col-lg-8  mx-auto mt-5">
                        <h3 class="text-center">
                            Great news!... MySwitchPro has identified a deal<br />
                            that will save you an estimated <span class="text-success">&pound;{{ savings }}</span><br />
                            over the course of a year!<br />
                        </h3>
                        <h5 class="text-center">Once you have signed up, we will continue to monitor the market and secure you more savings as and when they become available to you.</h5>
                        <hr class="w-75 mx-auto mt-4" />
                    </div>
                </div>
                <div class="row" v-if="hasBestDeal">
                    <div class="col-12 col-lg-8  mx-auto mt-5">
                        <h3 class="text-center">
                            MySwitchPro will now start monitoring the energy suppliers and tariffs on the market to find the best plans for you.
                        </h3>
                        <hr class="w-75 mx-auto mt-4" />

                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-10 mx-auto my-4">
                        <h5 class="text-center ">In order to continue and show you the savings, we just need to verify that  you are a real person.</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6 mx-auto">
                        <registration-form />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RegistrationForm from "@/components/auth/RegistrationForm";
import store from '@/store'
import {EventBus, events} from "@/utils/event-bus";

export default {
        name: "Register",
        components: {RegistrationForm},
        computed: {
            savings: function () {
                return this.$store.getters['setup/estimate'];
            },
            hasBestDeal: function (){
                return this.$store.getters['auth/hasWorthlessDeal']
            }
        },
        mounted() {
            let that = this;
            let signCallback = () => {
                if(that.$store.getters['auth/hasPendingDeal']){
                    if(that.$store.getters['auth/isVerified']){
                        that.$router.push({name: 'SetupDeal'})
                    } else {
                        that.$router.push({name: 'RegisterDone'})
                    }
                } else {
                    that.$router.push({name: 'Dashboard'})
                }
            };
            
            EventBus.$on(events.auth.signup, signCallback)
            EventBus.$on(events.auth.signin, signCallback)
        },
        destroyed() {
            EventBus.$off(events.auth.signin)
            EventBus.$off(events.auth.signup)
        },
        beforeRouteEnter: (to, from, next) => {
            if(store.getters['auth/isUser']){
                next({name: 'Dashboard'})
            } else {
                next()
            }
        }
    }
</script>

<style scoped lang="scss">
    .register {
        min-height: calc(100vh - 145px);
    }
</style>
